export default __webpack_public_path__ + "static/media/logo-light.ddef6342.png";